import React, { Fragment, useEffect, Component } from 'react';
import { ShoppingBag, Download, List, AlertCircle } from 'react-feather';
import request, { NodeURL, socket, socket_notify } from "../../../api/api";
import jwt_decode from "jwt-decode";
import { withRouter } from "react-router";
import noticloseIcon from "../../../images/candidate/close.svg";
import ReactTooltip from "react-tooltip";

class Notification extends Component {
    state = {
        notify: []
    }
    componentDidMount = () => {
        socket.on('candidate_notify', (data) => {
            const tokenAgency = localStorage.getItem("APUSEC");
            if (tokenAgency) {
                const token = jwt_decode(tokenAgency);
                if (token && token.user_id && data && data._id) {
                    if (String(token.user_id) === String(data._id)) {
                        // this.recent_notify();
                    }
                }
            }
        });

        socket.on('notifications_application_form_submnit', (data) => {
            const tokenAgency = localStorage.getItem("APUSEC");
            if (tokenAgency) {
                const token = jwt_decode(tokenAgency);
                if (token && token.user_id && data && data._id) {
                    if (String(token.user_id) === String(data._id)) {
                        // this.recent_notify();
                    }
                }
            }
        });

        socket.on('notifications_application_form_status', (data) => {
            const tokenAgency = localStorage.getItem("APUSEC");
            if (tokenAgency) {
                const token = jwt_decode(tokenAgency);
                if (token && token.user_id && data && data._id) {
                    if (String(token.user_id) === String(data._id)) {
                        // this.recent_notify();
                    }
                }
            }
        });

        socket_notify.on('web notification', (data) => {
            const tokenAgency = localStorage.getItem("APUSEC");
            if (tokenAgency) {
                const token = jwt_decode(tokenAgency);
                if (token && token.user_id && data && data.username && data.username.length > 0) {
                    if (String(token.user_id) === String(data.username)) {
                        // this.recent_notify();
                    }
                }
            }
        });

        socket_notify.on('web_notification', (data) => {
            const tokenAgency = localStorage.getItem("APUSEC");
            if (tokenAgency) {
                const token = jwt_decode(tokenAgency);
                if (token && token.user_id && data && data.username && data.username.length > 0) {
                    if (String(token.user_id) === String(data.username)) {
                        // this.recent_notify();
                    }
                }
            }
        });

        socket.on('notifications_todo', (data) => {
            const tokenAgency = localStorage.getItem("APUSEC");
            if (tokenAgency) {
                const token = jwt_decode(tokenAgency);
                if (token && token.user_id && data && data._id && data._id.length > 0) {
                    if (String(token.user_id) === String(data._id)) {
                        // this.recent_notify();
                    }
                }
            }
        });

        socket.on('recruitment_notify', (data) => {
            const tokenAgency = localStorage.getItem("APUSEC");
            if (tokenAgency) {
                const token = jwt_decode(tokenAgency);
                if (token && token.user_id && data && data._id && data._id.length > 0) {
                    if (String(token.user_id) === String(data._id)) {
                        // this.recent_notify();
                    }
                }
            }
        });

        socket.on('notifications', (data) => {
            const tokenAgency = localStorage.getItem("APUSEC");
            if (tokenAgency) {
                const token = jwt_decode(tokenAgency);
                if (token && token.user_id && data && data._id && data._id.length > 0) {
                    if (String(token.user_id) === String(data._id)) {
                        // this.recent_notify();
                    }
                }
            }
        });

        this.recent_notify();
    }

    recent_notify = () => {
        request({
            url: '/employee/get/recent/notify',
            method: 'POST',
            data: { limit: 5 }
        }).then(res => {
            if (res && +res.status === 1) {
                this.setState({ notify: res.response });
            }
        }).catch(err => {
            console.log(`err is ${err}`);
        })
    }

    continue_form = () => {
        return this.props.history.push('/notification/list')
    }

    render() {
        let { notify } = this.state;
        return (
            <Fragment>
                <ul className="notification-dropdown onhover-show-div active p-0">
                        <li><h2>Notification <span className="badge badge-pill badge-primary pull-right">{notify.length}</span></h2></li>
						<div className="notifi-scroll">
                        {
                            notify.map((item, index) => {
                                return (
                                    <li key={index}>
                                        <div className="media">
                                            <div className="media-body">
                                                <h6 className="mt-0">
                                                    <div className="profile-img notification-img">CL</div>
                                                </h6>
                                                <div className="notifi-text">
                                                    <p className="mb-0">{item.message}</p>
                                                    {item.raw_data && item.raw_data.notes && item.raw_data.notes !== '' ? <p className="mb-0">{item.raw_data.notes}</p> : null}
                                                    <span>15-09-2020 at 10:00</span>
                                                    </div>
                                                    <div className="notifi-close">
														<a href="#"><img src={noticloseIcon} data-tip data-for="clearTip" /></a>
														<ReactTooltip id="clearTip" place="bottom" effect="solid">
														Clear Notification
														</ReactTooltip>
														<button className="unread-color" data-tip data-for="unreadTip"><label></label></button>
														<ReactTooltip id="unreadTip" place="left" effect="solid">
														Mark as unread
														</ReactTooltip>
													</div>
                                            </div>
                                        </div>
                                    </li>
                                )
                            })
                        }
						<li className="unread">
                        <div className="media">
                            <div className="media-body">
                                <h6 className="mt-0">
                                    <div className="profile-img notification-img">CL</div>
                                </h6>
                                <div className="notifi-text">
                                    <p className="mb-0">Queen Elizabeth has been registered</p><span>15-09-2020 at 10:00</span>
                                </div>
                                <div className="notifi-close">
									<a href="#"><img src={noticloseIcon} data-tip data-for="clearTip" /></a>
									<ReactTooltip id="clearTip" place="bottom" effect="solid">
									Clear Notification
									</ReactTooltip>

                                    <button data-tip data-for="readTip"><label></label></button>
                                    <ReactTooltip id="readTip" place="left" effect="solid">
                                    Mark as read
                                    </ReactTooltip>
                                </div>
                            </div>
                        </div>
                    </li>
                        {/* <li>
                                <div className="media">
                                    <div className="media-body">
                                        <h6 className="mt-0"><span><ShoppingBag /></span>Your order ready for Ship..!</h6>
                                        <p className="mb-0">Lorem ipsum dolor sit amet, consectetuer.</p>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="media">
                                    <div className="media-body">
                                        <h6 className="mt-0 txt-success"><span><Download className="font-success" /></span>Download Complete</h6>
                                        <p className="mb-0">Lorem ipsum dolor sit amet, consectetuer.</p>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className="media">
                                    <div className="media-body">
                                        <h6 className="mt-0 txt-danger"><span><AlertCircle className="font-danger" /></span>250 MB trash files</h6>
                                        <p className="mb-0">Lorem ipsum dolor sit amet, consectetuer.</p>
                                    </div>
                                </div>
                            </li> */}
							</div>
                        <li className="txt-dark"><a onClick={(e) => { this.continue_form(e) }} >All notification </a> </li>
                </ul>
            </Fragment>
        );
    }
};

export default withRouter(Notification);